import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/san-francisco/redefine_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/san-francisco/redefine_new.webp"
              alt="app developers in San Francisco"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={486}
              height={651}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Redefine Your Business in the Digital Landscape of San Francisco
            </h2>
            <p>
              There’s a reason why TekRevol seeks disruption in the tech
              industry of San Francisco, especially in mobile app development.
              We acknowledge the potential that this city has to offer in the
              ever growing market of mobile apps. Therefore, our app developers
              in San Francisco, design, develop, and execute the most
              revolutionary digital solutions that set new standards for
              businesses.
            </p>
            <p>
              The growing tech innovations in the city have created numerous
              opportunities for the development of mobile apps to stay
              competitive and digitally storm. As a result, it drives our
              passion for reinventing traditional boundaries, starting with
              apps.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
